<template>
  <router-view/>
</template>

<style>
body{
  margin: 0 auto;
  padding: 0;
}
</style>
